import { createFileRoute, redirect } from '@tanstack/react-router'

// Self-service sign-up is NOT allowed on N.E.S.T. — operators are provisioned,
// never self-registered. The Cognito pool is shared with the mobile app (which
// keeps its own signup), so we must NOT disable signup pool-wide; instead this
// route is removed at the SPA level: any hit redirects to the terminal login.
// (#449)
export const Route = createFileRoute('/(auth)/sign-up')({
  beforeLoad: () => {
    throw redirect({ to: '/sign-in' })
  },
})
